const images = {
  logo: require("~/assets/images/logo.svg").default,
  kimcuong: require("~/assets/images/kimcuong.svg").default,
};

export default images;
